import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ClaimEpinComponent } from './claim-epin.component';
import { EpinInfoComponent } from '../../../components/epin-info/epin-info.component';
import { EpinInfoModule } from '../../../components/epin-info/epin-info.component.module';
import { EpinClaimSuccessComponent } from '../../../components/epin-claim-success/epin-claim-success.component';
import { EpinClaimSuccessModule } from '../../../components/epin-claim-success/epin-claim-success.component.module';
import { SmallToCryptoPipeModule } from '../../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.module';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        RouterModule.forChild([{ path: '', component: ClaimEpinComponent }]),
        TranslateModule,
        EpinInfoModule,
        EpinClaimSuccessModule,
        SmallToCryptoPipeModule
    ],
    exports: [ClaimEpinComponent],
    declarations: [ClaimEpinComponent],
    entryComponents: [EpinInfoComponent, EpinClaimSuccessComponent]
})
export class ClaimEpinModule { }
